import React from 'react';
import TooltipTrigger from "react-popper-tooltip";

export function getVerificationBadgeSpan(type) {
  if (type === undefined || type === null) {
    return ('');
  }

  switch (type) {
    case 'BUSINESS':
      return (
          <span className="ico_plus">공식계정</span>
      );
    case 'PUBLIC_INSTITUTION':
    case 'CELEBRITY':
      return (
          <span className="ico_plus ico_badge">공공기관 및 유명인</span>
      );
    case 'NONE':
    default:
      return ('');
  }

}

export function getVerificationBadgeClassName(type) {
  if (type === undefined || type === null) {
    return ('');
  }

  switch (type) {
    case 'BUSINESS':
      return 'ico_biz'
    case 'PUBLIC_INSTITUTION':
    case 'CELEBRITY':
      return 'ico_public'
    case 'NONE':
    default:
      return ('');
  }

}

export function isVerification(type) {
    if (type !== undefined) {
        if (type === 'BUSINESS' || type === 'PUBLIC_INSTITUTION') {
            return true;
        }
    }
    return false;
}

export function renderBadge(type) {
    if (type !== undefined) {
        if (type === 'PUBLIC_INSTITUTION') {
            return (
                <button type="button" className="btn_auth">
                    <span className="ico_plus ico_badge">공공기관/인물</span>
                </button>
            );
        }else if(type === 'BUSINESS') {
            return renderTooltip();
        }
    }
    return;
}

export function renderTooltip() {
    const tooltip = ({ getTooltipProps, getArrowProps, tooltipRef, arrowRef, placement }) =>
        (
            <div
                {...getTooltipProps({
                    ref: tooltipRef,
                    className: 'tooltip-container',
                    style: {
                        width: '178px',
                        textAlign: 'center',
                        border: '1px solid rgba(0,0,0,0.1)',
                        borderRadius: '5px',
                        padding: '8px 15px 8px 15px',
                        fontSize: '12px',
                        fontWeight: 'normal',
                        boxShadow: '5px 5px 11px rgba(0,0,0,0.1)'
                    }
                })}
            >
                <div
                    {...getArrowProps({
                        ref: arrowRef,
                        'data-placement': placement,
                        className: 'tooltip-arrow'
                    })}
                />
                <p>카카오에서 정보를 확인한 채널입니다</p>
            </div>
        );

    const trigger = ({ getTriggerProps, triggerRef }) =>
        (
            <button type="button" className="btn_auth">
              <span {...getTriggerProps({
                  ref: triggerRef,
                  className: 'ico_plus ico_biz'
              })}
              >
                비즈니스채널
              </span>
            </button>

        );

    return (
        <TooltipTrigger placement='top' tooltip={tooltip}>
            {trigger}
        </TooltipTrigger>
    );
}


// WEBPACK FOOTER //
// ./src/utils/profileUtils.js